import React from 'react';
import { graphql, useFragment } from 'react-relay/hooks';
import { Button, Flexbox, Text } from '@sonika-se/ui-kit/components';
import UserNameLabel from '~/components/UserNameLabel';
export const UserPickerListItem = (props) => {
    const { onSelect, userRef } = props;
    const user = useFragment(graphql `
      fragment UserPickerListItem_user on User {
        ...UserNameLabel_user
        id
      }
    `, userRef);
    return (<Flexbox justify="space">
      <Text>
        <UserNameLabel user={user}/>
      </Text>
      <Button onClick={() => onSelect(user.id)} size="small">
        Välj
      </Button>
    </Flexbox>);
};
export default UserPickerListItem;
